import { UniDriver } from '@wix/unidriver-core';
import { baseUniDriverFactory } from '../utils/test-utils/unidriver';

export const proportionDriverFactory = (base: UniDriver) => {
  const byHook = (dataHook: string) => base.$(`[data-hook="${dataHook}"]`);

  return {
    ...baseUniDriverFactory(base),

    /**
     * Gets the component's aspect ratio
     * @returns {Promise<number>}
     */
    getAspectRatio: async (): Promise<number> => {
      const width = await base.attr('offsetWidth');
      const height = await base.attr('offsetHeight');
      return +(width ?? 1) / +(height ?? 1);
    },

    /**
     * Checks whether aspect ratio is disabled
     * @returns {Promise<boolean>}
     */
    isAspectRatioDisabled: async (): Promise<boolean> =>
      byHook('proportion-aspect').exists(),
  };
};

export type ProportionUniDriver = ReturnType<typeof proportionDriverFactory>;
